import { Injectable } from '@angular/core';
import { from, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { PopupService } from '@apps/clos-sessions/shared/popup/services/popup.service';

@Injectable({
  providedIn: 'root',
})
export class BrowserWarningModalService {
  constructor(protected popupService: PopupService) {}

  open(): Observable<void> {
    return from(import('@apps/clos-sessions/shared/modules/browser-warning-modal')).pipe(
      switchMap(({ BrowserWarningModalComponent }) =>
        this.popupService.open({
          id: 'BrowserWarningModalComponent',
          wrapped: false,
          type: BrowserWarningModalComponent,
        }),
      ),
    );
  }
}
